import { render, staticRenderFns } from "./editdriverRecruit.vue?vue&type=template&id=9aa8e61a&scoped=true&"
import script from "./editdriverRecruit.vue?vue&type=script&lang=js&"
export * from "./editdriverRecruit.vue?vue&type=script&lang=js&"
import style0 from "./editdriverRecruit.vue?vue&type=style&index=0&id=9aa8e61a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aa8e61a",
  null
  
)

export default component.exports